import { ThemeUICSSObject } from 'theme-ui';
/* IMPORT HERE */

const Switch: ThemeUICSSObject = {
  '+ span': {
    fontSize: 14,
    fontWeight: 'normal',
    wordBreak: 'break-all',
  },
  backgroundColor: 'form.fields.checked.borderColor',
};

export default Switch;
